/**
 *
 * ScrollablePaper
 *
 */

import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Spacings from '~/modules/ui-kit/spacings';
import Scrollable from '~/components/Scrollable';

import styles from './styles.module.css';
import { Box, Typography } from '@mui/material';

type ScrollablePaperProps = {
  isLoading?: boolean;
  paperClass?: string;
  contentClass?: string;
  title: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  isExpandable?: boolean;
  isClosedPerDefault?: boolean;
};

const ScrollablePaper = (props: ScrollablePaperProps) => {
  const [expanded, setExpanded] = useState(!props.isClosedPerDefault);
  return (
    <Paper className={props.paperClass}>
      <Scrollable
        className={props.contentClass}
        header={
          <div>
            <Spacings.Inline>
              <Box sx={{ px: 2, py: 1, flexGrow: 1, alignSelf: 'center' }}>
                <Typography
                  variant="subtitle2"
                  style={{ flexGrow: 1 }}
                  color="textSecondary"
                >
                  {props.title}
                </Typography>
              </Box>
              {props.isExpandable && (
                <IconButton onClick={() => setExpanded(!expanded)} size="large">
                  <ExpandMoreIcon
                    color="action"
                    style={{
                      transform: `rotate(${expanded ? '180' : '0'}deg)`,
                      transition: 'transform 300ms',
                    }}
                  />
                </IconButton>
              )}
            </Spacings.Inline>
            <Divider />
          </div>
        }
        footer={props.footer}
      >
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {props.isLoading ? (
            <div className={styles['fetching-wrapper']}>
              <CircularProgress aria-label="loading" size={60} />
            </div>
          ) : (
            props.children
          )}
        </Collapse>
      </Scrollable>
    </Paper>
  );
};

export default ScrollablePaper;
